import { Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

import LinkBlock from './LinkBlock';
import React from 'react';

const useStyles = makeStyles(theme => ({
    block: {
        overflow: "hidden",
        "& *": {
            transitionDuration: theme.transitions.duration.standard,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
        },
        "& .MuiButton-endIcon": {
            //transitionProperty: "color",
            color: theme.palette.secondary.muted,
            marginTop: ".25rem",
        },
        "&:hover .MuiButton-endIcon": {
            color: theme.palette.primary.main,
        },
        "& .MuiButton-startIcon path": {
            //transitionProperty: "fill",
            fill: theme.palette.secondary.muted,
        },
        "&:hover .MuiButton-startIcon path": {
            fill: theme.palette.primary.main,
        },
        "&:hover $heading": {
            color: '#fff',
        },
        borderRadius: 0,
        justifyContent: "space-between",
    },
    heading: {
        margin: 0,
        marginTop: ".25rem",
        color: theme.palette.secondary.muted,
        textTransform: "uppercase",
    },
}));

export default function CategoryListLinkBlock({ number, label, minHeight = "0rem", ...props }) {

    const classes = useStyles();

    const blockProps = {
        endIcon: typeof number !== 'undefined' ? () => <>{number}</> : undefined,
        ...props,
    }

    return (
        <LinkBlock className={classes.block} style={{minHeight}} fullWidth={true} padding="2rem" {...blockProps}>
            <Typography variant="body1" component="h3" className={classes.heading}>{label}</Typography>
        </LinkBlock>
    );
}